import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";

import { BehaviorSubject, asyncScheduler } from "rxjs";
import { throttleTime } from "rxjs/operators";

import { AutoSubOnDestroy, AutoSub } from "../../providers/auto-sub";

@AutoSubOnDestroy()
@Component({
    selector: 'html-input',
    template: `
        <ngx-monaco-editor 
            #monacoEditor
            *ngIf="editorModel"
            class="code-editor" 
            (click)="$event.stopImmediatePropagation()" 
            [options]="{    language: 'html',
                            automaticLayout: true,
                            wordWrap: 'false',
                            wrappingIndent: 'none' }" 
            [model]="editorModel" [ngModel]="inputModel" (ngModelChange)="inputChangeSubject.next($event)">
        </ngx-monaco-editor>
    `
})
export class HtmlInputComponent {
    @Input() set model(model: any) {
        if(!this.editorModel) console.error("Could not set model json, model uri not initialized yet (please set modelUri input first)");
        // else this.editorModel.value = model.replace(/([^\n|^\r|^ ])(<)/g, '$1\n<');
        else this.editorModel.value = model;
        // This is needed to update model on second load
        this.inputModel = this.editorModel.value;
    }

    @Output() modelChange = new EventEmitter<any>();

    public editorModel = { value: '', language: 'html' };
    public inputModel: any;
    public inputChangeSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor() {
        // Listen for editor json changes
        AutoSub(this).reg['editorChangeSub'] = this.inputChangeSubject.pipe(throttleTime(1500, asyncScheduler, { leading: true, trailing: true })).subscribe((jsonStr) => {
            this.updateModel(jsonStr);
        });
    }

    public updateModel(modelStr: string) {
        this.modelChange.emit(modelStr);
    }
}
